import React from 'react';

import routeDetails from 'app/constants/routeDetails';
import glyphs from 'app/constants/glyphs';
import strings from 'app/locales/footer';

import Link from 'app/components/Link';
import Icon from 'app/components/Icon';

import styles from './styles.css';

const SocialLink = ({ href, icon, text }) => (
  <a href={href} target="_blank" className={styles.socialLink}>
    <Icon className={styles.socialIcon} icon={glyphs[icon]} title={text} />
    <span className={styles.socialText}>{text}</span>
  </a>
);

const Footer = () => (
  <div className={styles.container}>
    <div className={styles.grid}>
      <h3 className={styles.headline}>{strings.headline}</h3>
      <div
        className={styles.text}
        dangerouslySetInnerHTML={{ __html: strings.text }}
      />

      <div
        className={styles.substackContainer}
        dangerouslySetInnerHTML={{ __html: strings.substack }}
      />

      <div className={styles.socialContainer}>
        {strings.socialLinks.map(link => {
          const { href, icon, text } = link;
          return <SocialLink key={text} href={href} icon={icon} text={text} />;
        })}
      </div>

      <Link
        className={styles.privacyPolicy}
        to={routeDetails.PRIVACY_POLICY.url}
        label={strings.privacyPolicy}
      />
      <p className={styles.copyright}>{strings.copyright}</p>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js